import { render, staticRenderFns } from "./photo-nerve.vue?vue&type=template&id=67a60fae&scoped=true&"
import script from "./photo-nerve.vue?vue&type=script&lang=js&"
export * from "./photo-nerve.vue?vue&type=script&lang=js&"
import style0 from "./photo-nerve.vue?vue&type=style&index=0&id=67a60fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a60fae",
  null
  
)

export default component.exports